<template>
    <div id="stepTips">
        <div class="pubw">
                <div class="b">
                    <div class="right">
                        <div class="title">
                            <span class="el-icon-s-opportunity icon"></span>
                            <span>{{title}}</span>
                        </div>
                        <div class="text">
                            <span>{{text}}</span>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
// 引人组件
export default {
    mame:'StepTips',
    props:["title","text"],
    components:{
    },
    data() {
        return {
            // 面积表单
            acreageForm:{
                length:'',
                width:'',
                height:''
            },
            // 面积表单规则
            acreageRyleForm:{
                length:[
                    {retuired:true,message:'* 必需填寫。',tirgger:'blur'}
                ],
                width:[
                {retuired:true,message:'* 必需填寫。',tirgger:'blur'}
                ],
                height:[
                {retuired:true,message:'* 必需填寫。',tirgger:'blur'}
                ]
            },
            // 重量表单
            weightForm:{
                weight:'',
            },
            // 重量表单规则
            weightRyleForm:{
                weight:[
                    {retuired:true,message:'* 必需填寫。',tirgger:'blur'}
                ]
            }
        }
    },
    mounted() {
    },
    methods: {
    
    },
    computed:{

    }
}
</script>

<style lang="less" scoped>
        .b{
            display: flex;
            align-items: center;
            width: 100%;
            height: 75px;
            background-color: #f1efff;
            border-radius: 10px;
            margin-top: 30px;
            padding: 30px 20px;
            .right{
                display: flex;
                flex-wrap: wrap;
                width: 50%;
                div{
                    width: 100%;
                    span{
                        margin:8px 0;
                    }
                    .icon{
                        color:#ffe108;
                        margin-right: 5px;
                    }
                }
            }
        }
/* 最大宽度768px 手机 */
@media screen and (max-width: 768px){

}
</style>